import Cookies from 'js-cookie'

const AigcToken = 'aigc-yiihuu-token'
const AigcOid = 'aigc-yiihuu-oid'
var expirationTime

export function getToken() {
  if (Cookies.get(AigcToken)) {
    return Cookies.get(AigcToken)
  } else {
    removeToken()
    return ''
  }
}

export function setToken(token) {
  expirationTime = new Date(new Date().getTime() + 12 * 60 * 60 * 1000);
  Cookies.set(AigcToken, token, { expires: expirationTime })
}

export function removeToken() {
  Cookies.remove(AigcToken)
}

export function getOid() {
  if (Cookies.get(AigcOid)) {
    return Cookies.get(AigcOid)
  } else {
    removeOid()
    return ''
  }
}

export function setOid(oid) {
  expirationTime = new Date(new Date().getTime() + 12 * 60 * 60 * 1000);
  Cookies.set(AigcOid, oid, { expires: expirationTime })
}

export function removeOid() {
  Cookies.remove(AigcOid)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js